//  Copyright 2023
//  Myriota Pty Ltd
//  Myriota Confidential

import { createStyles } from '@mui/styles';
import withStyles from '@mui/styles/withStyles';
import * as React from "react";
import { Redirect, Route, Switch } from "react-router";
import AccessTimesComponent from "src/components/AccessTimesComponent";
import DestinationComponent from "src/components/DestinationsComponent";
import ModulesComponent from "src/components/ModulesComponent";
import HeaderComponent from './HeaderComponent';
import PageNotFoundComponent from "src/app/PageNotFoundComponent";

const styles = createStyles({
    container: {
        height: "100vh",
        minHeight: 396,
        flexDirection: "row",
        display: "flex",
        overflow: "hidden",
    },
    mainContent: {
        flex: 1,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
    },
    mainRoutesContainer: {
        overflow: "auto",
    },
});


export class AppComponent extends React.Component<any, any> {
    render() {
        const cssClasses = this.props.classes;
        return (
            <div className={cssClasses.container}>
                <div className={cssClasses.mainContent}>
                    <HeaderComponent />
                    <div className={cssClasses.mainRoutesContainer}>
                        <Switch>
                            <Route path="/accesstimes" render={() => <AccessTimesComponent yamlFile={'access_times_api.yaml'} />} />
                            <Route path="/modules" render={() => <ModulesComponent yamlFile={'modules_api.yaml'} />} />
                            <Route path="/destinations" render={() => <DestinationComponent yamlFile={'destinations_api.yaml'} />} />
                            <Route path="/devicecontrol" render={() => <DestinationComponent yamlFile={'control_messages_api.yaml'} />} />
                            <Redirect from="/" exact to="/modules" />
                            <Route component={PageNotFoundComponent} />
                        </Switch>
                    </div>
                </div>
            </div>
        );
    }
}


export default withStyles(styles)(AppComponent);
